<template>
  <module-list-layout :createAction="createAction" :module="module" class="p-2" v-if="amReady">

    <el-dialog :visible.sync="callerHistoryViewerDialog" title="" top="1vh" width="92%" @close="closeCallsViewerDialog">
      <broadcastHistory v-if="callerHistoryViewerDialog" :fusionServerId="currentSelectedFusionServer" :sipDialerId="currentSelectedSipDialer"></broadcastHistory>
    </el-dialog>

    <el-dialog :visible.sync="callerViewerDialog" title="" top="5vh" width="80%" @close="closeCallsViewerDialog">
      <voipGenerateLiveUserActiveCalls v-if="callerViewerDialog" :targetEntityId="currentSelectedFusionServer" getBy="fusionServer" callDirection="outbound"></voipGenerateLiveUserActiveCalls>
    </el-dialog>

    <el-dialog :visible.sync="logViewerDialog" title="" top="5vh" width="75%" @close="closeLogViewerDialog">
      <div v-if="singleRecordLog">
        <el-row :key="pKey" class="mb-2 w-100" v-for="(pKey, pVal) in logViewerData">
          <el-col :md="6" :lg="4" :sm="6">
            <span v-html="pVal" class="text-uppercase log-title"></span>
          </el-col>
          <el-col :md="18" :lg="20" :sm="18">
            <span class="app-bg-gold-low-alfa p-2" v-html="pKey" style="display: inline-block;width: calc(100% - 350px);word-break: break-all;"></span>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <el-row :key="mpKey" class="mb-2 w-100" v-for="(mpKey) in logViewerData">
          <el-row :key="pKey" class="mb-2 w-100" v-for="(pKey, pVal) in mpKey">
            <el-col :md="6" :lg="4" :sm="6">
              <span v-html="pVal" class="text-uppercase log-title"></span>
            </el-col>
            <el-col :md="18" :lg="20" :sm="18">
              <span class="app-bg-gold-low-alfa p-2" v-html="pKey" style="display: inline-block;width: calc(100% - 350px);word-break: break-all;"></span>
            </el-col>
          </el-row>
        </el-row>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="96%">
      <moduleForm
          :autoBind="false"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :formTitle="((editMode)? 'Update ' : 'Create ') + module.info.caption"
          :moduleDeleteAction='moduleFormDeleteAction'
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-6 pt-1">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search here"></dg-text-field>
      </div>
      <div class="col-12 col-md-6 pt-1">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
    </div>

    <el-table
        :data="rowData"
        border
        cell-class-name="p-1"
        stripe
        style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
              :data="[props.row]"
              border
              cell-class-name="p-1"
              header-cell-class-name="app-light-silver-background p-1"
              style="width: 100%;">
            <el-table-column
                label="Destination"
                prop="destination">
            </el-table-column>
            <el-table-column
                label="Rate"
                width="100"
                prop="rate">
            </el-table-column>
            <el-table-column
                label="Vendor">
              <template slot-scope="scope">
                <statusViewer title="" :data="scope.row.vendor" :content="'Prefix: ' + scope.row.vendor_prefix"></statusViewer>
              </template>
            </el-table-column>
            <el-table-column
                label="Caller"
                prop="caller_id">
              <template slot-scope="scope">
                <smartInputView :customParams="scope.row" inputWidth='200px' editContainerStyle="top: 0" :saveAction="updateField"
                                :inputValue="scope.row.caller_id" fieldName='caller_id' :noCopy="true"></smartInputView>
              </template>
            </el-table-column>
            <el-table-column
                label="Type"
                width="80"
                prop="call_test_type">
            </el-table-column>
            <el-table-column
                label="Digits Between"
                width="150"
                prop="digits_between_prefix_and_number">
              <template slot-scope="scope">
                <statusViewer title="Digits Between Prefix and numbers" :data="scope.row.digits_between_prefix_and_number" content=""></statusViewer>
              </template>
            </el-table-column>
            <el-table-column
                label="Created"
                width="150"
                prop="created_at">
            </el-table-column>
          </el-table>

          <el-table
              :data="[props.row]"
              border
              cell-class-name="p-1"
              header-cell-class-name="app-light-silver-background p-1"
              style="width: 100%;margin-top: 15px">
            <el-table-column
                label="Calls Interval"
                prop="delay_between_calls_in_ms">
              <template slot-scope="scope">
                <smartInputView :customParams="scope.row" inputWidth='200px' editContainerStyle="top: 0" :saveAction="updateField"
                                :inputValue="scope.row.delay_between_calls_in_ms" fieldName='delay_between_calls_in_ms' :noCopy="true"></smartInputView>
              </template>
            </el-table-column>
            <el-table-column
                label="Loop Delay"
                prop="loop_delay_in_ms">
              <template slot-scope="scope">
                <smartInputView :customParams="scope.row" inputWidth='200px' editContainerStyle="top: 0" :saveAction="updateField"
                                :inputValue="scope.row.loop_delay_in_ms" fieldName='loop_delay_in_ms' :noCopy="true"></smartInputView>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
          label="Fusion"
          width="250"
          sortable>
        <template slot-scope="scope">
          <statusViewer title="" :data="scope.row.fusion_server.name" :content="scope.row.fusion_server.url"></statusViewer>
        </template>
      </el-table-column>
      <el-table-column
          label="Title"
          prop="title"
          width="250"
          sortable>
        <template slot-scope="scope">
          <smartInputView :customParams="scope.row" inputWidth='160px' editContainerStyle="top: 0;"
              :inputValue="scope.row.title" fieldName='title' :saveAction="updateField" :noCopy="true"></smartInputView>
        </template>
      </el-table-column>
      <el-table-column
          label="Numbers"
          width="300">
        <template slot-scope="scope">
          <statusViewer title="Dialer Numbers" :content="scope.row.bc_phone_numbers" data="">
            <template v-slot:body>
              <smartInputView :customParams="scope.row" inputWidth='240px' editContainerStyle="top: 0;" style="width: 200px;overflow:hidden;white-space: nowrap;height: 25px;text-overflow: ellipsis"
                              :inputValue="scope.row.bc_phone_numbers" fieldName='bc_phone_numbers' :saveAction="updateField" :noCopy="true"></smartInputView>
            </template>
          </statusViewer>
        </template>
      </el-table-column>
      <el-table-column
          label="Ports"
          width="130px"
          prop="number_of_ports">
        <template slot-scope="scope">
          <smartInputView :customParams="scope.row" inputWidth='70px' editContainerStyle="top: 0" :saveAction="updateField"
                    :inputValue="scope.row.number_of_ports" fieldName='number_of_ports' :noCopy="true"></smartInputView>
        </template>
      </el-table-column>
      <el-table-column
          label="Interval"
          width="150px"
          prop="delay_between_calls_in_ms">
        <template slot-scope="scope">
          <smartInputView :customParams="scope.row" inputWidth='200px' editContainerStyle="top: 0" :saveAction="updateField"
            :inputValue="scope.row.delay_between_calls_in_ms" fieldName='delay_between_calls_in_ms' :noCopy="true"></smartInputView>
        </template>
      </el-table-column>
      <el-table-column
          label="Division"
          width="100px"
          prop="division_abbre">
      </el-table-column>
      <el-table-column
          label="Dialer Online"
          width="180px">
        <template slot-scope="scope">
          <callsControl :sipDialer="scope.row" :status="scope.row.calls_are_active" :testId="scope.row.id"></callsControl>
          {{scope.row.number_of_calls_to_make}}
        </template>
      </el-table-column>
      <el-table-column
          align="right"
          label="Actions"
          prop="">
        <template slot-scope="scope">
          <vDropdown :actionsHandler="actionsHandler" :items="usersActions"
                     :params="{data: scope.row, rowIndex: scope.$index + 1} "></vDropdown>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="420px">
      <div align="center" class="mt-2 mb-2">You want to remove this record ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>
  </module-list-layout>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'


export default {
  components: {
    broadcastHistory: () => import('./../../broadcast-history/View'),
    vDropdown: () => import('@/components/button-dropdown/View'),
    callsControl: () => import('./ag-grid/CallsControl'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue'),
    statusViewer: () => import('@/components/popover/View'),
    smartInputView: () => import("@/components/smart-input-view/View"),
    voipGenerateLiveUserActiveCalls: () => import('@/modules/voip-generate-live-user-active-calls/view/View'),
  },
  data() {
    return {
      currentSelectedSipDialer: null,
      logViewerIntervalHandler: null,
      callerHistoryViewerDialog: false,
      logViewerDialog: false,
      currentSelectedFusionServer: null,
      singleRecordLog: true,
      logViewerData: [],
      callerViewerDialog: false,
      rowData: [],
      usersActions: [
        {
          label: 'History',
          icon: 'el-icon-view',
          action: 'openCallsHistoryViewer'
        },
        {
          label: 'Outbound Calls',
          icon: 'el-icon-view',
          action: 'openCallsViewer'
        },
        {
          label: 'View Log',
          icon: 'el-icon-view',
          action: 'openLogViewer'
        },
        {
          label: 'Remove',
          icon: 'el-icon-delete',
          action: 'removeAction'
        }
      ],
      intervalHandler: null,
      deleteDialogVisible: false,
      targetParams: null,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeDestroy() {
    clearInterval(this.intervalHandler)
    clearInterval(this.logViewerIntervalHandler)
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
    /*this.intervalHandler = setInterval(() => {
      this.getEntityListData(this.currentPage, true)
    }, 12000)*/
  },
  methods: {
    openLogViewer(params) {
      let testId = params.data.id
      let monitorModeForTackingActions = params.data.monitor_mode_for_tacking_actions == 1
      let interval = (monitorModeForTackingActions)? 1000 : 4000
      this.getLogViewerData(testId, 'log')
      this.logViewerIntervalHandler = setInterval(() => {this.getLogViewerData(testId, 'log')}, interval)
      this.logViewerDialog = true;
    },
    closeLogViewerDialog(params) {
      this.logViewerData = []
      clearInterval(this.logViewerIntervalHandler)
      this.logViewerDialog = false;
    },
    updateField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.id,
        data
      }

      this.updateEntity(apiParams).then(r => {
        afterSave()
        notify({
          type: 'success',
          title: "Updated",
        });
      }).catch( e => {
        afterSave()
        notify({
          type: 'error',
          title: "Failed",
        });
      })
    },
    getLogViewerData (testId, logType) {
      this.readLog({id: testId, status: logType}).then( r => {
        if (r.length && typeof r[0] == 'object') {
          this.singleRecordLog = false
          this.logViewerData = r
        } else {
          this.singleRecordLog = true
          //this.logViewerData = JSON.parse(r)
          this.logViewerData = r
        }

      })
    },
    openCallsHistoryViewer(params) {
      let testId = params.data.id
      this.currentSelectedFusionServer = params.data.fusion_server_id
      this.currentSelectedSipDialer = params.data.id
      this.callerHistoryViewerDialog = true;
    },
    openCallsViewer(params) {
      let testId = params.data.id
      this.currentSelectedFusionServer = params.data.fusion_server_id
      this.callerViewerDialog = true;
    },
    closeCallsViewerDialog(params) {
      this.logViewerData = []
      this.callerViewerDialog = false;
    },
    getEntityListData(page, noLoadingScreen = false) {
      let data = {page: page, search: this.userSearch}
      if (noLoadingScreen) data['noLoadingScreen'] = true
      this.getEntityList(data).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.rowData = null
      $vue.nextTick(() => {
        this.rowData = response.rows
        this.recordsCounter = response.count
        this.amReady = true
      })
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions(module.info.name + '-api', {
      updateEntity: 'update',
      getEntityList: 'list',
      readLog: 'readLog'
    }),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: this.module.info.routeName + '->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.getEntityListData(1, false)
    },
    afterEdit(updatedData, propertyName = false, closeDialog = true) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      if (propertyName) {
        this.rowData[this.rowToEdit][propertyName] = updatedData;
      } else {
        this.rowData[this.rowToEdit] = updatedData;
      }

      if (closeDialog) this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.rowData.push(newEntity);
      this.dialogVisible = false;
      this.getEntityListData(1, false)
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: this.module.info.routeName + '->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.targetParams = params
      this.deleteDialogVisible = true
    },
    removeActionApi() {
      let params = this.targetParams
      this.deleteDialogVisible = false
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
